import { CircularProgress } from "@mui/material"

import { useParams } from "react-router-dom"
import { useGetOperationHistoryDetails } from "../../api/hooks/useGetOperationHistoryDetails"
import SbpOutcomeTransferHistoryDetails from "../../components/OperationHistoryDetails/SbpOutcomeTransferHistoryDetails"
import { OperationType } from "../../api/interface"
import SbpIncomeTransferHistoryDetails from "../../components/OperationHistoryDetails/SbpIncomeTransferHistoryDetails"
import AgentPaymentHistoryDetails from "../../components/OperationHistoryDetails/AgentPaymentHistoryDetails"
import ProviderPaymentHistoryDetails from "../../components/OperationHistoryDetails/ProviderPaymentHistoryDetails"
import OutcomeTransferHistoryDetails from "../../components/OperationHistoryDetails/OutcomeTransferHistoryDetails"
import IncomeTransferHistoryDetails from "../../components/OperationHistoryDetails/IncomeTransferHistoryDetails"
import RefillPaymentHistoryDetails from "../../components/OperationHistoryDetails/RefillPaymentHistoryDetails"
import ServicePaymentHistoryDetails from "../../components/OperationHistoryDetails/ServicePaymentHistoryDetails"
import { LoadingWindow } from "../styled"
import BalanceAdjustmentPaymentHistoryDetails from "../../components/OperationHistoryDetails/BalanceAdjustmentPaymentHistoryDetails"
import SbpPaymentHistoryDetails from "../../components/OperationHistoryDetails/SbpPaymentHistoryDetails"

const OperationHistoryDetails = () => {
  const { operationId } = useParams()
  const { data: operation } = useGetOperationHistoryDetails(operationId!)
  if (operation) {
    switch (operation.type) {
      case OperationType.AGENT_PAYMENT:
        return <AgentPaymentHistoryDetails operation={operation} />
      case OperationType.AGENT_PAYMENT_REFUND:
        return <AgentPaymentHistoryDetails operation={operation} isRefund />
      case OperationType.PROVIDER_PAYMENT:
        return <ProviderPaymentHistoryDetails operation={operation} />
      case OperationType.PROVIDER_PAYMENT_REFUND:
        return <ProviderPaymentHistoryDetails operation={operation} isRefund />
      case OperationType.OUTCOME_TRANSFER:
        return <OutcomeTransferHistoryDetails operation={operation} />
      case OperationType.OUTCOME_TRANSFER_REFUND:
        return <OutcomeTransferHistoryDetails operation={operation} isRefund />
      case OperationType.INCOME_TRANSFER:
        return <IncomeTransferHistoryDetails operation={operation} />
      case OperationType.INCOME_TRANSFER_REFUND:
        return <IncomeTransferHistoryDetails operation={operation} isRefund />
      case OperationType.REFILL_PAYMENT:
        return <RefillPaymentHistoryDetails operation={operation} />
      case OperationType.REFILL_PAYMENT_REFUND:
        return <RefillPaymentHistoryDetails operation={operation} isRefund />
      case OperationType.SBP_OUTCOME_PAYMENT:
        return <SbpPaymentHistoryDetails operation={operation} direction="outcome" />
      case OperationType.SBP_PAYOUT:
      case OperationType.SBP_REFUND:
        return <SbpPaymentHistoryDetails operation={operation} direction="income" />
      case OperationType.SBP_OUTCOME_TRANSFER:
        return <SbpOutcomeTransferHistoryDetails operation={operation} />
      case OperationType.SBP_INCOME_TRANSFER:
        return <SbpIncomeTransferHistoryDetails operation={operation} />
      case OperationType.SERVICE_PAYMENT:
        return <ServicePaymentHistoryDetails operation={operation} />
      case OperationType.SERVICE_PAYMENT_REFUND:
        return <ServicePaymentHistoryDetails operation={operation} isRefund />
      case OperationType.BALANCE_ADJUSTMENT_PAYMENT:
        return <BalanceAdjustmentPaymentHistoryDetails operation={operation} />

      default:
        return <SbpOutcomeTransferHistoryDetails operation={operation} />
    }
  }

  return (
    <LoadingWindow>
      <CircularProgress />
    </LoadingWindow>
  )
}

export default OperationHistoryDetails
